import React from 'react';
import ExpandableApcmEligibilityFilters from 'components/templates/apcm/practice/eligibilityReport/expandable-filters';
import ApcmEligibilityReportHeader from 'components/templates/apcm/practice/eligibilityReport/header';
import ApcmEligibilityReportTable from 'components/templates/apcm/practice/eligibilityReport/table';
import { useInteractiveTimeDashboardFilters } from 'infrastructure/hooks/interactiveTimeDashboard/useFilters';
import { useInteractiveTimeDashboardSendReport } from 'infrastructure/hooks/interactiveTimeDashboard/useSendReport';
import { useInteractiveTimeDashboardData } from 'infrastructure/hooks/interactiveTimeDashboard/useData';
import { minutesToSeconds } from 'date-fns';

const actionTimeGte = minutesToSeconds(80);

const ApcmEligibilityReport: React.FC = () => {
  const { resetFilters, appendFilters, changePage, filters, filtersCount } =
    useInteractiveTimeDashboardFilters({
      interactionFlagStartTime: null,
      interactionFlagEndTime: null,
      actionTimeGte,
      patientIcdCodesLengthGte: 2,
      patientApcmStatuses: [
        { label: 'Active', value: 'active' },
        { label: 'Pending Review', value: 'pending_review' },
      ],
      lastReadingStartTime: null,
      assignee: null,
    });

  const { data, isLoading } = useInteractiveTimeDashboardData(filters);

  const { isLoading: sendReportIsLoading, sendReportToEmail } =
    useInteractiveTimeDashboardSendReport({
      ...filters,
      reportType: 'apcmEligibility',
    });

  return (
    <>
      <ApcmEligibilityReportHeader
        sendReportIsLoading={sendReportIsLoading}
        sendReportToEmail={sendReportToEmail}
      />
      <ExpandableApcmEligibilityFilters
        data={filters}
        count={filtersCount}
        updateFilter={appendFilters}
        resetFilter={resetFilters}
      />
      <ApcmEligibilityReportTable
        eligibilityData={data}
        filters={filters}
        isLoading={isLoading}
        changePage={changePage}
      />
    </>
  );
};

export default ApcmEligibilityReport;
